import React, { useState } from "react";
import PropTypes from "prop-types";
import { FieldArray } from "formik";
import SubformList from "./parts/subform-list";
import SubformListSortable from "./parts/subform-list-sortable";
import AddSubformButton from "./parts/add-subform-button";
import withStyles from "components/with-styles";
import styles from "./styles/form-composed.css.js";



const FormComposed = ({ sortable = false, classes, addSubformButtonText, emptyElement, name, eventCopy, ...props }) => {
  const [newElementAdded, setNewElementAdded] = useState(false);

  const List = sortable ? SubformListSortable : SubformList;

  const handleAdd = push => () => {
    push(typeof emptyElement === "function" ? emptyElement() : emptyElement);
    setNewElementAdded(true);
  };

  return (
    <FieldArray
      name={name}
      render={({ push, ...arrayProps }) => (
        <div className={classes.subform}>
          <List name={name} newElementAdded={newElementAdded} eventCopy={eventCopy} {...props} {...arrayProps} />
          <AddSubformButton text={addSubformButtonText} onClick={handleAdd(push)} />
        </div>
      )}
    />
  );
};

FormComposed.propTypes = {
  /**
   * Indica si la lista se puede ordenar
   */
  sortable: PropTypes.bool,
  /**
   * Nuevo objeto al hacer click en añadir
   */
  emptyElement: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]).isRequired,
  /**
   * Nombre del array que contiene los elementos del subformulario
   */
  name: PropTypes.string.isRequired,
  /**
   * Array con los elementos del subformulario
   */
  elements: PropTypes.array,
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Callback que se llama al cambiar el estado del formulario compuesto
   */
  onChange: PropTypes.func,
  /**
   * Componente que renderiza un elemento a su representación en formulario
   */
  elementComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  /**
   * Props adicionales para el componente del elemento
   */
  elementComponentProps: PropTypes.object,
  /**
   * Texto para el botón de añadir subformulario
   */
  addSubformButtonText: PropTypes.string,
};

export default withStyles(styles)(FormComposed);
